// extracted by mini-css-extract-plugin
export default {"component":"PieChart_component__0IFCP","pie":"PieChart_pie__6Ti8B","pieInnerCircle":"PieChart_pieInnerCircle__Ufzg9","darkMode":"PieChart_darkMode__sZS3Y"};